import React from "react";
import { Loader2, Pencil, Trash2 } from "lucide-react";
import freightService from "@/services/freightService";

/**
 * Card de uma faixa de distância (docs/tela/code.html): faixa, status,
 * regra "a partir de / abaixo de", taxa fixa e ações.
 */
export default function FreightRateCard({
  rate,
  overlaps = [],
  loadingEdit = false,
  deleting = false,
  onEdit,
  onDelete,
}) {
  const range = freightService.formatRange(rate);

  return (
    <article className="flex flex-col gap-2.5 rounded-xl border bg-card p-3.5 shadow-soft transition-shadow hover:shadow-ambient">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <h4 className="font-display text-lg font-semibold text-foreground">
              {range}
            </h4>
            <span className="inline-flex items-center gap-1 rounded-full bg-brand-pistachio/30 px-2 py-0.5 text-[11px] font-semibold text-brand-dark">
              <span className="h-1.5 w-1.5 rounded-full bg-primary" />
              Ativa
            </span>
            {overlaps.length > 0 && (
              <span
                className="inline-flex items-center rounded-full bg-terra-soft px-2 py-0.5 text-[11px] font-semibold text-terra"
                title={`Sobrepõe: ${overlaps.map((r) => freightService.formatRange(r)).join(", ")}`}
              >
                Sobreposta
              </span>
            )}
          </div>
          <p className="mt-0.5 text-xs text-muted-foreground">
            a partir de {freightService.formatDistance(rate.minDistanceKm)} e
            abaixo de {freightService.formatDistance(rate.maxDistanceKm)}
          </p>
        </div>
        <div className="flex flex-shrink-0 flex-col items-end">
          <span className="text-[11px] font-semibold text-muted-foreground">
            Taxa fixa
          </span>
          <span className="whitespace-nowrap font-display text-lg font-bold text-primary">
            {freightService.formatCurrency(rate.freightValue)}
          </span>
        </div>
      </div>

      <div className="flex items-center justify-end gap-2 rounded-lg bg-surface/60 px-2.5 py-1.5">
        <button
          type="button"
          onClick={() => onEdit(rate)}
          disabled={loadingEdit || deleting}
          aria-label={`Editar faixa ${range}`}
          className="inline-flex h-8 items-center gap-1 rounded-full bg-surface-high px-3 text-[11px] font-semibold text-muted-foreground transition-colors hover:text-primary disabled:opacity-60"
        >
          {loadingEdit ? (
            <Loader2 className="h-3.5 w-3.5 animate-spin" />
          ) : (
            <Pencil className="h-3.5 w-3.5" />
          )}
          Editar
        </button>
        <button
          type="button"
          onClick={() => onDelete(rate)}
          disabled={loadingEdit || deleting}
          aria-label={`Excluir faixa ${range}`}
          className="inline-flex h-8 items-center gap-1 rounded-full bg-destructive/10 px-3 text-[11px] font-semibold text-destructive transition-colors hover:bg-destructive/20 disabled:opacity-60"
        >
          {deleting ? (
            <Loader2 className="h-3.5 w-3.5 animate-spin" />
          ) : (
            <Trash2 className="h-3.5 w-3.5" />
          )}
          Excluir
        </button>
      </div>
    </article>
  );
}
